<span type="button" class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon full-screen-exit">fullscreen_exit</mat-icon>
</span>
<dp-shipment-bing-maps [shipmentDetail]="shipmentDetail" [trackingType]="trackingType"></dp-shipment-bing-maps>